import ICNote from '@assets/jsx-icon/ICNote';
import BaseListNote, { tableHeaders } from '@components/BaseListNote';
import StyledDateRangePicker from '@components/date-range-select/StyledDateRangePicker';
import { CellOfRow } from '@components/tables';
import { Grid, TableCell, Typography } from '@mui/material';
import { useContext } from 'react';
import { formatDateTime } from 'src/helpers';
import { PotentialContraventionContext } from '../hooks/PotentialContraventionProvider';
import DetailInfoSection from './DetailInfoSection';
import { TypeReturn } from '@components/styled-autocomplete/useStyledAutocomplete';
import { Camera } from '@EcamModel/model';
import { ListProps } from '@Core';

export default function NoteOPs(props: { camerasAutocomplete?: TypeReturn<Camera, ListProps<Camera>> }) {
    const pcContext = useContext(PotentialContraventionContext);

    const { filter, setFilter, isLoading, listNotes, selectedCamera, handleChangeCamera } = pcContext;

    return (
        <DetailInfoSection
            icon={<ICNote />}
            borderRadius={'0px 8px 8px 8px'}
            title="Verifier note"
            action={
                <>
                    <Grid container xs={9} justifyContent={'flex-end'}>
                        <Grid xs={5}>
                            <StyledDateRangePicker
                                value={{
                                    startDate: filter?.from || undefined,
                                    endDate: filter?.to || undefined,
                                }}
                                onChange={(value) => {
                                    setFilter({
                                        from: value.startDate,
                                        to: value.endDate,
                                        page: 1,
                                    });
                                }}
                                dateReset={{ startDate: undefined, endDate: undefined }}
                                label={'Select date'}
                            />
                        </Grid>
                    </Grid>
                </>
            }
            content={
                <BaseListNote
                    paging={listNotes}
                    isLoading={isLoading}
                    tableHeaders={tableHeaders}
                    styleContainer={{ m: 2 }}
                    setPage={(page) => {
                        setFilter((prev) => ({ ...prev, page }));
                    }}
                    renderedItem={(item) => {
                        return (
                            <>
                                <CellOfRow value={formatDateTime(item.Created!)} align="left" />
                                <CellOfRow value={item.CreatedBy ?? ''} align="left" />
                                <CellOfRow value={formatDateTime(item.Updated!)} align="left" />
                                <TableCell
                                    align="left"
                                    sx={{
                                        wordWrap: 'break-word',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word',
                                    }}
                                >
                                    <Typography>{item.Notes.trim() ?? ''}</Typography>
                                </TableCell>
                            </>
                        );
                    }}
                />
            }
            selectedCamera={selectedCamera}
            handleChangeCamera={handleChangeCamera}
            camerasAutocomplete={props.camerasAutocomplete}
        />
    );
}
